import archivoLatin from '@fontsource-variable/archivo/files/archivo-latin-wght-normal.woff2?url';
import sourceSansLatin from '@fontsource-variable/source-sans-3/files/source-sans-3-latin-wght-normal.woff2?url';

import { env } from './env';

/**
 * Connections and files worth starting before the browser discovers them (§48).
 *
 * Only the Latin subsets of the two families are preloaded. They carry every
 * word on the page; the other subsets stay lazy, fetched only if a visitor
 * actually needs those characters.
 */
export const preloadFonts = [archivoLatin, sourceSansLatin];

/**
 * Supabase serves both the data and the vehicle photographs. Opening the
 * connection during HTML parse saves the DNS, TCP and TLS round trips that
 * would otherwise delay the first request — worth the most on a slow mobile
 * connection.
 */
export const preconnectOrigins: string[] = (() => {
  if (!env.supabaseUrl) return [];
  try {
    return [new URL(env.supabaseUrl).origin];
  } catch {
    return [];
  }
})();
